module.exports = __webpack_public_path__ + "static/media/2_r_kreslo_88.33_80.28.465b79e8.png";